// 시작 전 sample
export const status0 = {
  info: {
    startDate: '2025-03-20T00:00:00', // 시작일
    endDate: '2025-03-27T00:00:00', // 종료일
    releaseDate: '2025-03-31T00:00:00', // 발표일
    cntParticipant: 3, //참여자수
    isParticipate: false,
  },
  result: {
    point: null, // 발표전에는 null
    isReceived: false, // true 면 수령완료
  },
  list: [
    {
      img: '',
      name: 'e편한세상청계1',
      caseNo: '2024타경1',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계2',
      caseNo: '2024타경2',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계3',
      caseNo: '2024타경3',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계4',
      caseNo: '2024타경4',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계5',
      caseNo: '2024타경5',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
  ],
};

// 진행중 & 아직 제출 안함 sample
export const status1 = {
  info: {
    startDate: '2025-03-16T00:00:00', // 시작일
    endDate: '2025-03-24T00:00:00', // 종료일
    releaseDate: '2025-03-26T00:00:00', // 발표일
    cntParticipant: 3, //참여자수
    isParticipate: false,
  },
  result: {
    point: null, // 발표전에는 null
    isReceived: false, // true 면 수령완료
  },
  list: [
    {
      img: '',
      name: 'e편한세상청계1',
      caseNo: '2024타경1',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계2',
      caseNo: '2024타경2',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계3',
      caseNo: '2024타경3',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계4',
      caseNo: '2024타경4',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계5',
      caseNo: '2024타경5',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: null, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: null, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
  ],
};

// 제출 완료 sample
export const status2 = {
  info: {
    startDate: '2025-03-16T00:00:00', // 시작일
    endDate: '2025-03-24T00:00:00', // 종료일
    releaseDate: '2025-03-26T00:00:00', // 발표일
    cntParticipant: 3, //참여자수
    isParticipate: true,
  },
  result: {
    point: null, // 발표전에는 null
    isReceived: false, // true 면 수령완료
  },
  list: [
    {
      img: '',
      name: 'e편한세상청계1',
      caseNo: '2024타경1',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 0, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: false, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계2',
      caseNo: '2024타경2',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 1, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: true, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계3',
      caseNo: '2024타경3',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 1, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: true, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계4',
      caseNo: '2024타경4',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 0, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: false, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계5',
      caseNo: '2024타경5',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 0, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: false, // 배팅여부
      answer: null, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: null, // 발표전에는 null
    },
  ],
};

// 발표 완료 sample
export const status3 = {
  info: {
    startDate: '2025-03-06T00:00:00', // 시작일
    endDate: '2025-03-16T00:00:00', // 종료일
    releaseDate: '2025-03-17T00:00:00', // 발표일
    cntParticipant: 3, //참여자수
    isParticipate: true,
  },
  result: {
    point: 125, // 발표전에는 null
    isReceived: false, // true 면 수령완료
  },
  list: [
    {
      img: '',
      name: 'e편한세상청계1',
      caseNo: '2024타경1',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 0, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: false, // 배팅여부
      answer: 1, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: 0, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계2',
      caseNo: '2024타경2',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 1, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: true, // 배팅여부
      answer: 1, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: 25, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계3',
      caseNo: '2024타경3',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 1, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: true, // 배팅여부
      answer: 1, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: 25, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계4',
      caseNo: '2024타경4',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 0, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: true, // 배팅여부
      answer: 0, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: 25, // 발표전에는 null
    },
    {
      img: '',
      name: 'e편한세상청계5',
      caseNo: '2024타경5',
      appraisedValue: 10, // 감정평가액
      minimumBidPrice: 10, // 최저매각가격
      state: '유찰 1회 (80%)',
      choice: 0, // 0: 낙찰, 1: 유찰  선택전에는 null
      isBet: true, // 배팅여부
      answer: 0, // 0: 낙찰, 1: 유찰  발표전에는 null
      point: 25, // 발표전에는 null
    },
  ],
};
